<template>
    <select-box :id="'adaptivity_order-'+protocolName" v-model="selectedValue" :options="adaptivityOptions" :omitLabel="true" :disabled="!isEditable" />
</template>

<script>

export default {
    name: "AdaptivitySelector",
    props: {
        entity: Object,
        idProtocol: Number|String,
        isEditable: Boolean,
        protocolName: String,
    },
    data () {
        return {
            selectedValue: null,
        }
    },
    mounted() {
        this._updateSelectedValue();

    },
    methods: {
        _updateSelectedValue() {
            let actualEntityValue = this.entity.protocols[this.idProtocol]['adaptivity_order'];
            let sameValueId = null;

            for (let value of this.availableValues) {
                if (this._arraysEqual(value.data, actualEntityValue)) {
                    sameValueId = value.id;
                    break;
                }
            }

            this.selectedValue = sameValueId;
        },
        _arraysEqual(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            if (a.length !== b.length) return false;

            for (var i = 0; i < a.length; ++i) {
                if (a[i] !== b[i]) return false;
            }

            return true;
        },
        _updateEntityAdaptivityOrder(newAdaptivity) {
            this.entity.protocols[this.idProtocol]['adaptivity_order'] = [...newAdaptivity.data];
        }
    },
    computed: {
        availableValues() {
            return [
                {
                    id: 0,
                    name: this.$gettext("Pouze adaptivní stream"),
                    data: [true],
                },
                {
                    id: 1,
                    name: this.$gettext("Pouze neadaptivní stream"),
                    data: [false]
                },
                {
                    id: 2,
                    name: this.$gettext("Upřednostnit adaptivní stream"),
                    data: [true, false]
                },
                {
                    id: 3,
                    name: this.$gettext("Upřednostnit neadaptivní stream"),
                    data: [false, true]
                }
            ]
        },
        adaptivityOptions() {
            return this._.map(this.availableValues, function (item) {
                return {id: item['id'], text: item['name']}
            })
        },
    },
    watch: {
        selectedValue (newValue, oldValue) {
            if (oldValue !== null) {
                this._updateEntityAdaptivityOrder(this.availableValues.find((value) => value.id === ~~newValue));
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/AdaptivitySelector.vue